import CircularProgress from '@mui/material/CircularProgress';
import { Typography } from '@components/Typography';
import { RATING_COLOR_RAMP } from '@constants/colors';
import { Completeness, completenessLevelForScore } from '@constants/companies';

const PROGRESS_COLOR_BY_LEVEL = {
    [Completeness.Critical]: RATING_COLOR_RAMP[0],
    [Completeness.Low]: RATING_COLOR_RAMP[1],
    [Completeness.Average]: RATING_COLOR_RAMP[2],
    [Completeness.Good]: RATING_COLOR_RAMP[3],
    [Completeness.Excellent]: RATING_COLOR_RAMP[4],
};

const ProfileProgress = ({ value, level }) => {
    const color = PROGRESS_COLOR_BY_LEVEL[level ?? completenessLevelForScore(value ?? 0)];
    return (
        <span style={{ display: 'inline-block', position: 'relative', width: '40px', height: '40px' }}>
            <CircularProgress variant="determinate" value={value} size={40} sx={{ color }} />
            <Typography
                variant="caption"
                sx={{
                    color: 'var(--text-primary)',
                    fontSize: '10px !important',
                    top: 0,
                    left: 0,
                    bottom: 0,
                    right: 0,
                    position: 'absolute',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                {value}%
            </Typography>
        </span>
    );
};

export default ProfileProgress;
